import React from "react";

const Container = ({ children }: React.PropsWithChildren) => {
  return <div className="max-w-[1300px] w-full mx-auto px-4">{children}</div>;
};

export default Container;
